<template>
  <div>
    <div class="gallery-container">
      <div
        class="gallery-thumbnail"
        v-for="(image, imageIndex) in gallery"
        :style="{ 'background-image': `url(/static/images/agc/gallery/${image})` }"
        @click="index = imageIndex"
      ></div>
    </div>

    <gallery
      :images="gallery.map(image => `/static/images/agc/gallery/${image}`)"
      :index="index"
      @close="index = null"
      :options="{ displayClass: 'blueimp-gallery-display-fix' }"
    />
  </div>
</template>

<script>
  import Gallery from 'vue-gallery';

  const gallery = require
  .context('static/images/agc/gallery/', true, /\.(jpg)$/)
  .keys()
  .map(categories => categories.split('/').pop());

  export default {
    name: 'AgcGallery',
    data() {
      return {
        gallery,
        index: null,
      };
    },
    components: {
      Gallery,
    },
  };
</script>

 <style scoped>
  .gallery-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 16px;
  }

  .gallery-thumbnail {
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
    width: 200px;
    height: 200px;
    margin: 3px;
    cursor: pointer;
  }

  @media (max-width: 460px) {
    .gallery-thumbnail {
      width: 100vw;
      height: 100vw;
      margin: 1px -16px 1px -16px;
    }
  }
 </style>



// WEBPACK FOOTER //
// AgcGallery.vue?059adcae